export const DO_URI = 'nyc3.digitaloceanspaces.com';
export const DO_ORIGIN_URL = `https://${
  import.meta.env.VITE_DO_BUCKET_NAME
}.nyc3.digitaloceanspaces.com`;
export const DO_CDN_URL = `https://${
  import.meta.env.VITE_DO_BUCKET_NAME
}.nyc3.cdn.digitaloceanspaces.com`;
// Identidad propia: ningun valor por defecto apunta a dominios de terceros
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL || 'support@horizont3.com';
export const TUTORIALS_LINK = import.meta.env.VITE_TUTORIALS_URL || 'https://agro.horizont3.com';
export const CROP_VARIETAL_DOCS_LINK =
  import.meta.env.VITE_CROP_VARIETAL_DOCS_URL || 'https://agro.horizont3.com';

// Changing this forces logout and updates the new release card
export const APP_VERSION = '3.13.0';
export const VERSION_RELEASE_NOTES_LINK =
  import.meta.env.VITE_RELEASE_NOTES_LINK || 'https://agro.horizont3.com';

export const CONSENT_VERSION = '8.0';

export const BETA_BADGE_LINK = import.meta.env.VITE_BETA_BADGE_LINK || 'https://agro.horizont3.com';
